import { getUser } from '@/lib/auth'

export function requireRole (requiredRole) {
  return function (to, from, next) {
    const user = getUser()
    
    if (!user) {
      next({
        name: 'Login',
        query: { redirect: to.fullPath }
      })
      return
    }
    
    if (user.role !== requiredRole) {
      next({
        name: 'Dashboard',
        query: { error: 'insufficient_permissions' }
      })
      return
    }
    
    next()
  }
}

export function requireAdmin (to, from, next) {
  return requireRole('ADMIN')(to, from, next)
}
